<template lang="">
  <div class="bbs_filter">
    <div class="lft_area">
      <div class="bbs_info">
        <div class="total"><strong>
          {{ getCurrentCount() }}
        </strong> / {{ this.weddingListCount }}</div>
      </div>
    </div>
    <div class="rgt_area">
      <div class="bbs_srch">
        <select name="" id="" class="i_sel" v-model="searchType">
          <option
            v-for="option in searchOptions"
            :value="option.value"
          >{{ option.name }}</option>
        </select>
        <input type="text" class="i_txt" name="keyword" v-model="searchWord">
        <button type="button" class="bt_base gray btn_srch" @click="getSearch">검색</button>
      </div>
    </div>
  </div>

  <div class="bbs_list">
    <table class="bbs_tbl">
      <colgroup>
        <col style="width:40px">
        <col style="width:100px">
        <col style="width:100px">
        <col style="width:150px">
        <col style="width:200px">
        <col style="width:150px">
        <col style="width:auto">
        <col style="width:150px">
      </colgroup>
      <thead>
        <tr>
          <th scope="col">번호</th>
          <th scope="col">주문번호</th>
          <th scope="col">이벤트날짜</th>
          <th scope="col">캠페인</th>
          <th scope="col">신랑신부</th>
          <th scope="col">행사장</th>
          <th scope="col">상세주소</th>
          <th scope="col">비고</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(wedding, index) in weddingList"
        >
          <td>{{ index + 1 }}</td>
          <td>{{ wedding.orderNum }}</td>
          <td>
            <div class="ui_datetime">
              <span class="date">{{ wedding.eventDate }}</span>
              <span class="time"> {{ wedding.eventTime }}</span>
            </div>
          </td>
          <td class="subject type_wider">{{ wedding.campaignName }}</td>
                    <td>
            <div class="ui_datetime">
              <span class="date">신부: {{ wedding.brideName }} ({{ wedding.brideContactPhone }}) <br/></span>
              <span class="time">신랑: {{ wedding.groomName }} ({{ wedding.groomContactPhone }})</span>
            </div>
          </td>
          <td>
            <div class="ui_datetime">
              <span class="date">{{ wedding.eventLocationName }}</span>
              <span class="time">{{ wedding.eventLocationDetail }}</span>
            </div>
          </td>
          <td class="subject type_wider">{{ wedding.mapAddress }}</td>
          <td>
            <div class="ui_datetime">
              <span class="date">
                    <a
                          v-bind:href="'/invitation/' + wedding.orderNum"
                          class="btn_view"
                          target="_blank"
                          >초대장
                    </a> |
              </span>
              <span class="time">
                    <a
                          v-bind:href="'/invitation/kiosk/' + wedding.orderNum + '?kioskStyle=' + wedding.kioskStyle + '&page=1'"
                          class="btn_view"
                          target="_blank"
                          >키오스크
                    </a>
              </span>
            </div>

          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="paginate">
    <AdminPagination
      :totalPages = "totalPages()"
      :currentPage = "currentPage"
      @changePage = "changePage"
    />

    <div class="rgt_area">
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import AdminPagination from '@/components/common/AdminPagination.vue';

const adminWeddingModule = 'adminWeddingModule'

export default {
  components: {
    AdminPagination
  },

  data () {
    return {
      currentPage: 1,

      searchOptions: [
        { name: '전체', value: 'all' },{ name: '신부명', value: 'bride' },{ name: '신랑명', value: 'groom' },
        { name: '행사장', value: 'location' },
      ],
      searchType: '',
      searchWord: ''
    }
  },

  methods: {
    ...mapActions(adminWeddingModule, [
      'requestWeddingList'
    ]),


    totalPages() {
      return Math.ceil(this.weddingListCount / 10);
    },

    async changePage(page) {
      this.currentPage = page
      const {currentPage, searchType, searchWord} = this
      await this.requestWeddingList({currentPage, searchType, searchWord})
    },

    getCurrentCount() {
      const currentFirstCount = (this.currentPage - 1) * 10 + 1
      let currentLastCount = this.currentPage * 10
      if (parseInt(currentLastCount) > parseInt(this.weddingListCount)) {
        currentLastCount = this.weddingListCount
      }
      return currentFirstCount + '-' + currentLastCount
    },

    inviOpen (url) {
      window.open(url);
    },

    async getSearch() {
      if (this.searchWord === '') {
        //alert('검색어를 입력해주세요')
        //return
      }
      this.currentPage = 1
      const {currentPage, searchType, searchWord} = this
      await this.requestWeddingList({currentPage, searchType, searchWord})
    }


  },

  computed: {
     ...mapState(adminWeddingModule, [
      'weddingList',
      'weddingListCount'
    ]),
  },

  async mounted() {
    const {currentPage, searchType, searchWord} = this
    await this.requestWeddingList({currentPage, searchType, searchWord})
    this.searchType = 'all'
  }
}
</script>
<style lang="">

</style>